import { createColumnHelper } from '@tanstack/react-table';

import { Service } from '../../../types';

export const columnHelper = createColumnHelper<Service>();
